import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import SearchBar from '../../components/searchbar';
import ContainerTable from '../../layouts/containers/container-table';
import { stringToFriendlyDatetime } from '../../lib/helpers/datetime-helpers';
import ContainerIndex from '../../layouts/containers/container-index';
import Divider from '../../components/divider/divider';
import ContainerGrid from '../../layouts/containers/container-grid';
import Grid from '../../components/grid';
import InputsCounter from '../../components/inputs/inputs-counter';
import DateTimeInput from '../../components/inputs/date-time-input';
import LabelContainer from '../../components/label-container';
import meetingsApi from '../../lib/meetings/meetings-api';
import Blurred from '../../components/blurred';

import MediaHelper from '../../lib/helpers/media';
import Darkener from '../../components/darkener';

class MeetingsListing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            room: null,
            start: undefined,
            duration_mins: undefined,
            no_attendees: 1,
            quote: null,
            building: null,
            topBarRef: null,
            imageRef: null,
            oldImageRef: null,
        }
    }

    componentDidMount() {
        meetingsApi.getMeetingRoom(this.props.id).then(({ data }) => {
            this.setState({ room: data });
        });

        this.onResize()
    }

    onImageRef(ref) {
        if (this.state.imageRef === null) {
            this.setState({ imageRef: ref }, () => {
                this.resizeImage();
            })
        }
    }

    onTopBarRef(ref) {
        if (this.state.topBarRef === null) {
            this.setState({ topBarRef: ref }, () => {
                this.resizeImage();
            })
        }
    }

    onResize() {    
        this.resizeImage();

        window.addEventListener('resize', this.resizeImage.bind(this))
    }

    resizeImage() {
        const overflow = 100;

        if (this.state.imageRef !== null) {
            this.state.imageRef.style.height = `calc(300.96px + ${this.state.topBarRef?.offsetHeight}px + ${overflow}px)`;
        }
    }

    getQuote() {
        meetingsApi.getBookingQuote({
            start: this.state.start,
            duration_mins: this.state.duration_mins,
            no_attendees: this.state.no_attendees,
            meeting_room_id: this.props.id,
        }).then(({ data }) => {
            this.setState({ quote: data });
        })
    }

    onAttendeesChange(value) {
        if (value <= this.state.room?.max_attendees) {
            this.setState({ no_attendees: value }, () => this.getQuote());
        }
    }

    onStartChange({ start, duration }) {
        const date = dayjs(`${start.date} ${duration.start}`).utc();

        this.setState({ 
            start: date,
            duration_mins: duration?.duration_mins
        }, () => {
            this.getQuote();
        })
    }
    
    proceed() {
        const url = new URL(`${window.location.origin}/mydmc/meeting-rooms/${this.state.room.id}/book`);
        
        if (this.state.start !== null && this.state.start !== undefined) url.searchParams.append('start', this.state.start);
        if (this.state.duration_mins !== null && this.state.duration_mins !== undefined) url.searchParams.append('duration_mins', this.state.duration_mins);
        if (this.state.no_attendees !== null && this.state.no_attendees !== undefined) url.searchParams.append('no_attendees', this.state.no_attendees);

        window.location.href = url.href;
    }

    getFeaturedImage() {
        const image = this.state.room?.content?.room_feature_image?.[0];

        if (image?.file_name === undefined) return '';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    getGalleryImages() {
        const gallery = this.state.room?.content?.gallery || [];

        return gallery?.map(item => MediaHelper.formatPublicPath(`/images/${item?.file_name}`));
    }

    getLocation() {
        const { name, address_one, address_two, address_post_code, address_city } = this.state.room?.office_building || {
            name: '',
            address_one: '',
            address_two: '',
            address_post_code: '',
            address_city: ''
        };

        let string = [
            name,
            address_one,
            address_two,
            address_post_code,
            address_city
        ].filter(e => e !== undefined && e !== null);

        return string.join(', ');
    }

    render() {
        if (this.state.room === null) return null;

        const featuredImage = this.getFeaturedImage();
        const gallery = this.getGalleryImages();
        const location = this.getLocation();

        return (
            <Layout 
                theme="light"
                topTheme="light"
                topLeft={<Welcome title="Meeting Room" subtitle={this.state.room?.name} theme="light"/>}
                topRight={
                    <Row gap="20px">
                        <Button className="button--view" onClick={this.proceed.bind(this)}>Proceed to booking</Button>
                    </Row>
                }
                topBarRef={this.onTopBarRef.bind(this)}
            >
               <Darkener ref={this.onImageRef.bind(this)} className="meetings-listing__image-outer">
                    <div className="meetings-listing__image-outer" style={{ 
                        backgroundImage: `url('${featuredImage}')`
                    }}></div>
                </Darkener>
                
                <MinMaxLayout
                    main={
                        <List gap="20px" className="meetings-listing" divider={<Divider/>}>
                            <SixtyFourtyLayout
                                main={
                                    <List gap="50px">
                                        <div class="bac-bar">
                                            <p style={{ fontSize: '14px' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                    <path id="Path_689" data-name="Path 689" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM11,11v6h2V11Zm0-4V9h2V7Z" transform="translate(-2 -2)" fill="#fcfcfc"/>
                                                </svg>
                                                <b>Payment via BACS only</b> or using your <b>Membership Credits</b> (If Available)
                                            </p>
                                        </div>

                                        <Grid className="meetings-listing__info">
                                            <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Max Room Capacity</Container.Text>}>
                                                { this.state.room?.max_attendees }
                                            </LabelContainer>

                                            <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Hourly Rate</Container.Text>}>
                                                £{ this.state.room?.price_per_hour }
                                            </LabelContainer>

                                            <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Location</Container.Text>}>
                                                { location }
                                            </LabelContainer>
                                        </Grid>

                                        <Container>
                                            <Container.Header>
                                                <Container.Text fontSize="18px" color="#FF6933">Room Overview</Container.Text>
                                            </Container.Header>

                                            <Container.Content>
                                                <Container.Text fontSize="16px" color="#24191F" html={this.state.room?.content?.room_overview}></Container.Text>
                                            </Container.Content>
                                        </Container>

                                        <div className="meetings-listing__image" role="img" aria-label="Meeting Room Cover Image" style={{ backgroundImage: `url('${featuredImage}')`}}></div>

                                        <Container>
                                            <Container.Header>
                                                <Container.Text fontSize="18px" color="#FF6933">Room Features</Container.Text>
                                            </Container.Header>

                                            <Container.Content>
                                                <Grid 
                                                    className="meetings-listing__features"
                                                >
                                                    { this.state.room?.content?.features?.map((feature, index) => {
                                                        return (
                                                            <div key={index} className="meetings-listing__feature">
                                                                <img className="meetings-listing-feature__icon" src={MediaHelper.formatPublicPath(`/images/${feature?.icon}`)}/>
                                                                <h4 className="meetings-listing-feature__title">{ feature?.title }</h4>
                                                                <p className="meetings-listing-feature__description">{ feature?.description }</p>
                                                            </div>
                                                        )
                                                    })}
                                                </Grid>
                                            </Container.Content>
                                        </Container>
                                    </List>
                                }
                                sectionOne={
                                    {
                                        name: 'Availability',
                                        component: <Container className="meetings-listing__availability">
                                            <Container.Header>
                                                <Container.Text fontSize="20px" color="white">Room Name Availability</Container.Text>
                                            </Container.Header>
                                            <Container.Content className="meetings-listing-availability__content">
                                                <List gap="20px">
                                                    <LabelContainer label={<Container.Text fontSize="14px" color="#1976F8">Booking Date and Duration</Container.Text>}>
                                                        <DateTimeInput
                                                            onChange={this.onStartChange.bind(this)}
                                                            value={[
                                                                this.state.start,
                                                                this.state.duration_mins
                                                            ]}
                                                            room={{
                                                                meeting_room_id: this.state.room.id
                                                            }}
                                                        />
                                                    </LabelContainer>

                                                    <Blurred toggled={this.state.start === undefined}>
                                                        <InputsCounter
                                                            label={<Container.Text fontSize="14px" color="#1976F8">Number of attendees</Container.Text>}
                                                            max={this.state.room?.max_attendees}
                                                            onChange={this.onAttendeesChange.bind(this)}
                                                            value={this.state.no_attendees || 0}
                                                        />
                                                    </Blurred>

                                                    <Divider top="10px" bottom="10px" color="#15AAA6"/>

                                                    {/* <Container.Text fontSize="16px" color="#FCFCFC">Good news, this room is available!</Container.Text> */}

                                                    { this.state.quote !== null && <LabelContainer label={<Container.Text fontSize="14px" color="#1976F8">Cost of booking</Container.Text>}>
                                                        <Container.Text fontSize="20px" color="white">£{ this.state.quote?.total } Or { this.state.quote?.credits_required_for_booking } credits for members</Container.Text>
                                                    </LabelContainer> }
                                                    
                                                    <Blurred toggled={this.state.start === undefined || this.state.no_attendees === null}>
                                                        <Button className="button--view" onClick={this.proceed.bind(this)}>Proceed To Booking</Button>
                                                    </Blurred>
                                                   
                                                </List>
                                            </Container.Content>
                                        </Container>

                                    }
                                }
                            />

                            <Container>
                                <Container.Header>
                                    <Container.Text fontSize="18px" color="#929BA8">Gallery Block</Container.Text>
                                </Container.Header>

                                <Container.Content>
                                    <ContainerGrid>
                                        { gallery?.map(item => <div className="meetings-listing-gallery__item" style={{ backgroundImage: `url('${item}')` }}></div>) }
                                    </ContainerGrid>
                                </Container.Content>
                            </Container>
                        </List>
                    }
                />
            </Layout>   
            )
    }
}

const el = document.getElementById('meetings-listing');

if (el) {
    ReactDOM.render(<MeetingsListing id={el.getAttribute('data-id')}/>, el);
}
